import { createLocalStorageHelper } from '@phoenix/helpers/localstorage-helper';

export const WATCH_COMPARATOR_UPDATED = 'watch-comparator-update';
export const WATCH_COMPARATOR_TOGGLED = 'watch-comparator-toggled';

export const watchComparatorLocalStorageHelper = createLocalStorageHelper({
  name: 'watchComparator',
  updateEventName: WATCH_COMPARATOR_UPDATED,
  initialValue: [],
  scopeToCountry: false,
  parse: (raw) => {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  },
  serialize: JSON.stringify,
});
